import React from "react";
import { FaAngleRight } from "react-icons/fa6";

const EngHinToggleButton = ({
  selectedLanguage = "en",
  onLanguageChange,
  onBack,
  onSubmit,
  submitText = "Submit",
  showLanguageToggle = true,
}) => {
  return (
    <div className="mb-4 flex items-center justify-between">
    
      {/* Language Toggle */}
      {showLanguageToggle && (
        <div className="flex items-center gap-2 rounded-full bg-white p-1 shadow-sm">
          <button
            onClick={() => onLanguageChange?.("en")}
            className={`rounded-full px-4 py-2 transition-all ${
              selectedLanguage === "en"
                ? "bg-[#562566] text-white"
                : "text-gray-600"
            }`}
          >
            ENG
          </button>

          <button
            onClick={() => onLanguageChange?.("hi")}
            className={`rounded-full px-4 py-2 transition-all ${
              selectedLanguage === "hi"
                ? "bg-[#562566] text-white"
                : "text-gray-600"
            }`}
          >
           हिंदी
          </button>
        </div>
      )}

    </div>
  );
};

export default EngHinToggleButton;